module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBoldItalic.da6f476d.woff2";